import { render, staticRenderFns } from "./system.vue?vue&type=template&id=a4693c98&scoped=true&"
import script from "./system.vue?vue&type=script&lang=js&"
export * from "./system.vue?vue&type=script&lang=js&"
import style0 from "./system.vue?vue&type=style&index=0&id=a4693c98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4693c98",
  null
  
)

export default component.exports